module.exports = __webpack_public_path__ + "img/1.d48b7426.png";